module.exports = __webpack_public_path__ + "static/media/battery_50.e47f9739.svg";